import {
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { FabricSqlCopySource } from 'app/model/pipeline/copysource/fabric-sql.copysource';
import { FabricSqlCopySink } from 'app/model/pipeline/copysink/fabric-sql.copysink';
import { sqlServerMetadata } from './sql-server-metadata';
import { ModelConstants } from 'shell-models-lib';

export const fabricSqlMetadata: ILinkedServiceTypeMetadata = {
    ...sqlServerMetadata,
    copyJob: { ...sqlServerMetadata.copyJob, omitConnectionDatabaseFromDataset: false },
    type: adfModelTypeMap.fabricSql.linkedServiceType,
    displayName: stringResources.SQL_Database_DisplayText,
    icon: {
        className: 'svg-i_fabricSql'
    },
    category: ['Workspace'],
    dmtsCredentialConnectionType: adfModelTypeMap.fabricSqlCredential.linkedServiceType,

    copySourceTypes: [Metamodel.modelFor(FabricSqlCopySource).name],
    copySinkTypes: [Metamodel.modelFor(FabricSqlCopySink).name],

    supportDataFlowSource: false,
    supportDataFlowSink: false,
    dataflowSource: undefined,
    dataflowSink: undefined,

    supportCopyJobSource: true,
    supportCopyJobSink: true,
    cdc: {
        supportCDC: false
    },
    supportMultipleIncrementalColumns: true,

    supportStoredProcedureActivity: true,
    supportScriptActivity: true,

    pqoDataSourceOption: undefined,
    supportedAuthKindsInTrident: undefined,
    fabricArtifactType: ModelConstants.fabricSqlArtifactType,
    isKnownInPipelineContext: false,

    controls: [],
    additionalPropertiesInFabric: undefined
};
